import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';
import { OrganizationStore } from './organization/organization.types';
import { createOrganizationActions } from './organization/organization.actions';
import { useAuthStore } from './authStore';

export const useOrganizationStore = create<OrganizationStore>()(
  devtools(
    persist(
      (set, get) => ({
        currentOrganizationSlug: null,
        isLoading: true,

        ...createOrganizationActions(set, get, () => useAuthStore.getState()),
      }),
      {
        name: 'organization-storage',
        version: 2,
        migrate: (persistedState: unknown) => {
          const state = persistedState as Record<string, unknown> | null;
          return {
            currentOrganizationSlug:
              typeof state?.currentOrganizationSlug === 'string'
                ? state.currentOrganizationSlug
                : null,
          };
        },
        partialize: (state) => ({
          currentOrganizationSlug: state.currentOrganizationSlug,
        }),
      }
    ),
    {
      name: 'organization-store',
    }
  )
);

if (typeof window !== 'undefined') {
  let lastUserId: string | null = null;
  let isLoadingData = false;
  
  useAuthStore.subscribe((state, prevState) => {
    const userId = state.user?.id ?? null;
    const wasLoading = prevState?.loading ?? true;
    const isLoading = state.loading;
    
    const userChanged = userId !== lastUserId;
    const justFinishedLoading = wasLoading && !isLoading && userId;
    
    if (userChanged || justFinishedLoading) {
      if (isLoadingData) return;
      
      if (userId && !isLoading) {
        lastUserId = userId;
        isLoadingData = true;
        
        useOrganizationStore.getState().syncOrganizationFromSlug();
        isLoadingData = false;
      } else if (!userId && lastUserId) {
        lastUserId = null;
        useOrganizationStore.getState().clearOrganizationState();
      }
    }
  });
}

